import { defineStore } from 'pinia'
import axios from 'axios'
import { useToastsStore } from '@/stores/notifications/toasts'
import { useAuthStore } from '@/stores/user/auth'
import { getResponse, getError } from '@/composables/api'

export const useUserStore = defineStore({
   id: 'user',
   state: () => ({
      user: [],
      gotUser: false,

      storeToasts: useToastsStore(),
      storeAuth: useAuthStore(),
   }),
   actions: {
	  getUser() {
         this.gotUser = false

			axios.get('user')
			.then((response) => {
				this.user = getResponse(response)
            this.gotUser = true
			}).catch((response) => {
            this.storeToasts.sendToast(getError(response), 'danger')
			})
		},
      /**
         * Function: delete
         * @description Sends a delete requiest to the API
         * to delete the user.
      */
      delete() {
			axios.delete('user').then((response) => {
            this.storeAuth.unAuthenticate()
			})
      },
   }
})